module.exports = __webpack_public_path__ + "media/images/partners/boa-grey-c3289dcc748150f5569556e91e1749c5.jpg";